import { Component } from 'react';
import { AnchorLink, Icon } from 'platfi-ui-components';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';

import Carousel from 'modules/Onboarding/components/Carousel/Carousel';
import ProgressBar from 'modules/Onboarding/components/ProgressBar/ProgressBar';

import styles from './Wizzard.scss';

class Wizzard extends Component {
  static propTypes = {
    completeOnboarding: PropTypes.func.isRequired,
    config: PropTypes.array.isRequired,
    skipOnboarding: PropTypes.func.isRequired,
  };

  state = {
    stepIndex: 0,
  };

  nextStep = () => {
    const { stepIndex } = this.state;

    this.setStepIndex(stepIndex + 1);
  };

  previousStep = () => {
    const { stepIndex } = this.state;

    this.setStepIndex(stepIndex - 1);
  };

  setStepIndex = (stepIndex) => {
    this.setState({ stepIndex });
  };

  render() {
    const { completeOnboarding, config, skipOnboarding } = this.props;
    const { stepIndex } = this.state;
    const slidesConfig = config.filter(({ label = false }) => !!label);

    return (
      <div styleName="a-onboarding">
        <div styleName="a-onboarding__content">
          <div styleName="a-onboarding__header">
            <Icon className="a-svg-logo u-color-primary" icon="capitalise_logo" />

            <AnchorLink onClick={skipOnboarding} secondary styleName="a-onboarding__skip">
              {'Skip to Dashboard >'}

              <span styleName="a-onboarding__skip-accent">{'>'}</span>
            </AnchorLink>
          </div>

          <Carousel
            completeOnboarding={completeOnboarding}
            goToNextSlide={this.nextStep}
            goToPreviousSlide={this.previousStep}
            setSlideIndex={this.setStepIndex}
            skipOnboarding={skipOnboarding}
            slideIndex={stepIndex}
            slidesConfig={slidesConfig}
          />

          <div className="o-container-m" styleName="a-onboarding__progress">
            <ProgressBar activeIndex={stepIndex} status={slidesConfig} />
          </div>
        </div>
      </div>
    );
  }
}

export default CSSModules(Wizzard, styles);
